import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { SupplierService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Supplier } from '../../models'

const log = new Logger('SupplierDetailResolver')
@Injectable({ providedIn: 'root' })
export class SupplierDetailResolver implements Resolve<Observable<Supplier>> {
  constructor(
    private supplierService: SupplierService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['sid']
    
    return this.supplierService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/supplier']))
    )
  }
}
